











import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import NotificationItem from '@/components/ui/UiNotifications/UiNotificationItem.vue'

interface Data {}

interface Methods {
}

interface Computed {}
interface Props {}

export default Vue.extend({
  name: 'UiNotifications',
  components: {
    NotificationItem
  },
  computed: {
    notificationList () {
      return this.$store.getters['ui/notifications']
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
